import { useEffect, useState } from 'react';
import axios from 'axios';
import LightAdmin from 'components/headers/lightAdmin';
import AnimationRevealPage from 'helpers/AnimationRevealPage';
import Footer from "components/footers/FiveColumnWithInputForm.js";
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Swal from "sweetalert2";
import { Alert } from 'react-bootstrap';
import { FaEdit, FaTrash } from "react-icons/fa";
import { useTranslation } from 'react-i18next';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

const LOW_STOCK_THRESHOLD = 10;

const ProduitsAdmin = () => {
    const { i18n } = useTranslation();
    const { t } = useTranslation();
const [searchTerm, setSearchTerm] = useState("");
    const [products, setProducts] = useState([]);
    const [isAdmin, setIsAdmin] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const categoryOptions = [
      'Cadeaux',
      'Librairie & Papeterie',
      'Électroménager',
      'Accessoires Téléphone',
      'Montres',
      'Cosmétiques & Compléments Alimentaires',
      'Parfums',
      'Chaussures',
      'Textile & Habillement',
      'Bijou',
      'Matériaux de Construction',
      'Produits Naturels'
    ];

    const [newProduct, setNewProduct] = useState({
        Name: { fr: '', ar: '' },
        short_description: { fr: '', ar: '' },
        Description: { fr: '', ar: '' },
        user_price: '',
        distributeur_price: '',
        StockQuantity: '',
        Category: categoryOptions[0],
        image: ''
    });
    // Track expand/collapse state per product row for short and full descriptions
    const [expandShortById, setExpandShortById] = useState({});
    const [expandDescById, setExpandDescById] = useState({});

    const [editingProductId, setEditingProductId] = useState(null);
    const [loading, setLoading] = useState(false);
const [selectedCategory, setSelectedCategory] = useState("All"); // default: show all
    const [selectedProductIds, setSelectedProductIds] = useState([]);
    const [stockStatusFilter, setStockStatusFilter] = useState("all");
    const [discountValue, setDiscountValue] = useState("");
    const [stockChangeMode, setStockChangeMode] = useState("set");
    const [stockChangeValue, setStockChangeValue] = useState("");
    const [bulkLoading, setBulkLoading] = useState(false);

    // Re-run admin status + fetch when language changes (labels may depend on lang)
    useEffect(() => {
        checkAdminStatus();
        // checkAdminStatus does not change identity; safe to omit from deps intentionally
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [i18n.language]);

    const checkAdminStatus = () => {
        const adminStatus = localStorage.getItem('isAdmin') === '1';
        setIsAdmin(adminStatus);

        if (adminStatus) {
            fetchAllProducts();
        } else {
            console.error('Unauthorized: User is not an admin');
        }
    };

    // Helper to safely parse JSON only if looks like JSON
    const parseIfJson = (str) => {
        if (typeof str !== 'string') return str;
        const trimmed = str.trim();
        if ((trimmed.startsWith('{') && trimmed.endsWith('}')) || (trimmed.startsWith('[') && trimmed.endsWith(']'))) {
            try {
                return JSON.parse(trimmed);
            } catch {
                return str;
            }
        }
        return str;
    };

    const fetchAllProducts = async () => {
        try {
            const token = localStorage.getItem('authToken');
            if (!token) return;

            // Admin editing needs full multilingual fields; fetch without lang filter
            const response = await axios.get(`https://plateformewmg.cloud/api/admin/products`, {
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${token}`,
                },
            });

            if (response.status === 200) {
                const productsWithParsedFields = response.data.map(product => ({
                    ...product,
                    Name: parseIfJson(product.Name),
                    short_description: parseIfJson(product.short_description),
                    Description: parseIfJson(product.Description),
                }));
                setProducts(productsWithParsedFields);
            }
        } catch (error) {
            console.error(error);
        }
    };
const handleEdit = (productId) => {
  setEditingProductId(productId);
  const product = products.find(p => p.ProductID === productId);

  // Safely parse Name/Description
  let parsedName = parseIfJson(product.Name);
  if (typeof parsedName !== "object") {
    parsedName = { fr: product.Name || '', ar: '' };
  }

    let parsedShort = parseIfJson(product.short_description);
    if (typeof parsedShort !== "object") {
        parsedShort = { fr: product.short_description || '', ar: '' };
    }

  let parsedDescription = parseIfJson(product.Description);
  if (typeof parsedDescription !== "object") {
    parsedDescription = { fr: product.Description || '', ar: '' };
  }

    setNewProduct({
        Name: parsedName,
                short_description: parsedShort,
        Description: parsedDescription,
        user_price: product.user_price || '',
        distributeur_price: product.distributeur_price || '',
        Category: categoryOptions.includes(product.Category) ? product.Category : categoryOptions[0],
        StockQuantity: product.StockQuantity || '',
        image: product.image || ''
    });

  setShowModal(true);
};
    const handleDelete = async (productId) => {
        try {
            const token = localStorage.getItem('authToken');
            if (!token) {
                return;
            }

            Swal.fire({
                title: 'Êtes-vous sûr?',
                text: "Vous ne pourrez pas revenir en arrière!",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Oui, supprimer!',
                cancelButtonText: 'Annuler'
            }).then(async (result) => {
                if (result.isConfirmed) {
                    const response = await axios.delete(`  https://plateformewmg.cloud/api/admin/products/${productId}`, {
                        headers: {
                            Authorization: `Bearer ${token}`,
                        },
                    });

                    if (response.status === 200) {
                        setProducts(products.filter(product => product.ProductID !== productId));
                        Swal.fire(
                            'Supprimé!',
                            'Le produit a été supprimé.',
                            'success'
                        );
                    }
                }
            });
        } catch (error) {
            console.error(error);
        }
    };

    const buildFormDataForProduct = (product, overrides = {}) => {
        const payload = { ...product, ...overrides };
        const safeName = typeof payload.Name === 'object' && payload.Name !== null
            ? payload.Name
            : { fr: payload.Name || '', ar: '' };
        const safeShort = typeof payload.short_description === 'object' && payload.short_description !== null
            ? payload.short_description
            : { fr: payload.short_description || '', ar: '' };
        const safeDescription = typeof payload.Description === 'object' && payload.Description !== null
            ? payload.Description
            : { fr: payload.Description || '', ar: '' };

        const formData = new FormData();
        formData.append('Name', JSON.stringify(safeName));
        formData.append('Description', JSON.stringify(safeDescription));
        formData.append('short_description', JSON.stringify(safeShort));
        formData.append('user_price', payload.user_price ?? 0);
        formData.append('distributeur_price', payload.distributeur_price ?? 0);
        formData.append('StockQuantity', payload.StockQuantity ?? 0);
        formData.append('Category', payload.Category || '');

        if (payload.image instanceof File) {
            formData.append('image', payload.image);
        }

        return formData;
    };

    const applyDiscountToSelected = async () => {
        const discount = parseFloat(discountValue);
        if (!selectedProductIds.length) {
            Swal.fire(t('Erreur'), t('bulk_actions.select_products_first'), 'warning');
            return;
        }
        if (!Number.isFinite(discount) || discount <= 0) {
            Swal.fire(t('Erreur'), t('bulk_actions.invalid_discount'), 'warning');
            return;
        }

        setBulkLoading(true);
        try {
            const token = localStorage.getItem('authToken');
            if (!token) {
                setBulkLoading(false);
                return;
            }

            await Promise.all(selectedProductIds.map(async (productId) => {
                const product = products.find((p) => p.ProductID === productId);
                if (!product) return;

                const discountFactor = 1 - discount / 100;
                const updatedProduct = {
                    ...product,
                    user_price: (Number(product.user_price) || 0) * discountFactor,
                    distributeur_price: (Number(product.distributeur_price) || 0) * discountFactor,
                };

                const formData = buildFormDataForProduct(updatedProduct);

                await axios.post(
                    `  https://plateformewmg.cloud/api/admin/products/${productId}?_method=PUT`,
                    formData,
                    {
                        headers: {
                            'Content-Type': 'multipart/form-data',
                            Authorization: `Bearer ${token}`,
                        },
                    }
                );
            }));

            await fetchAllProducts();
            setSelectedProductIds([]);
            setDiscountValue('');
            Swal.fire('Succès', t('bulk_actions.discount_applied'), 'success');
        } catch (error) {
            console.error(error);
            Swal.fire(t('Erreur'), t('bulk_actions.discount_failed'), 'error');
        }
        setBulkLoading(false);
    };

    const applyStockChangeToSelected = async () => {
        const rawValue = parseInt(stockChangeValue, 10);
        if (!selectedProductIds.length) {
            Swal.fire(t('Erreur'), t('bulk_actions.select_products_first'), 'warning');
            return;
        }
        if (!Number.isFinite(rawValue)) {
            Swal.fire(t('Erreur'), t('bulk_actions.invalid_stock'), 'warning');
            return;
        }

        setBulkLoading(true);
        try {
            const token = localStorage.getItem('authToken');
            if (!token) {
                setBulkLoading(false);
                return;
            }

            await Promise.all(selectedProductIds.map(async (productId) => {
                const product = products.find((p) => p.ProductID === productId);
                if (!product) return;

                const currentStock = Number(product.StockQuantity) || 0;
                const newStock = stockChangeMode === 'set'
                    ? Math.max(0, rawValue)
                    : Math.max(0, currentStock + rawValue);

                const updatedProduct = {
                    ...product,
                    StockQuantity: newStock,
                };

                const formData = buildFormDataForProduct(updatedProduct);

                await axios.post(
                    `  https://plateformewmg.cloud/api/admin/products/${productId}?_method=PUT`,
                    formData,
                    {
                        headers: {
                            'Content-Type': 'multipart/form-data',
                            Authorization: `Bearer ${token}`,
                        },
                    }
                );
            }));

            await fetchAllProducts();
            setSelectedProductIds([]);
            setStockChangeValue('');
            Swal.fire('Succès', t('bulk_actions.stock_updated'), 'success');
        } catch (error) {
            console.error(error);
            Swal.fire(t('Erreur'), t('bulk_actions.stock_failed'), 'error');
        }
        setBulkLoading(false);
    };

    const handleShowModal = () => {
        setEditingProductId(null);
        setNewProduct({
            Name: { fr: '', ar: '' },
            short_description: { fr: '', ar: '' },
            Description: { fr: '', ar: '' },
            user_price: '',
            distributeur_price: '',
            Category: categoryOptions[0],
            StockQuantity: '',
            image: ''
        });
        setShowModal(true);
    };

    const handleCloseModal = () => setShowModal(false);

    const handleChange = (e) => {
        setNewProduct({ ...newProduct, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            const token = localStorage.getItem('authToken');
            if (!token) {
                setLoading(false);
                return;
            }

            const formData = new FormData();
            formData.append('Name', JSON.stringify(newProduct.Name));
            formData.append('Description', JSON.stringify(newProduct.Description));
            formData.append('short_description', JSON.stringify(newProduct.short_description));
            formData.append('user_price', newProduct.user_price);
            formData.append('distributeur_price', newProduct.distributeur_price);
            formData.append('StockQuantity', newProduct.StockQuantity);
            formData.append('Category', newProduct.Category);

            if (newProduct.image instanceof File) {
                formData.append('image', newProduct.image);
            }

            let response;
            if (editingProductId) {
                response = await axios.post(
                    `  https://plateformewmg.cloud/api/admin/products/${editingProductId}?_method=PUT`,
                    formData,
                    {
                        headers: {
                            'Content-Type': 'multipart/form-data',
                            Authorization: `Bearer ${token}`,
                        },
                    }
                );
            } else {
                response = await axios.post(
                    '  https://plateformewmg.cloud/api/admin/products',
                    formData,
                    {
                        headers: {
                            'Content-Type': 'multipart/form-data',
                            Authorization: `Bearer ${token}`,
                        },
                    }
                );
            }

            if (response.status === 200 || response.status === 201) {
                fetchAllProducts();
                handleCloseModal();
                Swal.fire(
                    'Succès!',
                    `Le produit a été ${editingProductId ? 'modifié' : 'ajouté'} avec succès.`,
                    'success'
                );
            }
        } catch (error) {
            console.error(error);
        }
        setLoading(false);
    };
    const filteredProducts = products
        .filter(product => {
            const name = i18n.language === "ar" ? (product.Name?.ar || product.Name?.fr || '') : (product.Name?.fr || product.Name?.ar || '');
            return name.toLowerCase().includes(searchTerm.toLowerCase());
        })
        .filter(product => selectedCategory === "All" ? true : product.Category === selectedCategory)
        .filter(product => {
            if (stockStatusFilter === 'all') return true;
            const quantity = Number(product.StockQuantity) || 0;
            if (stockStatusFilter === 'in-stock') return quantity > LOW_STOCK_THRESHOLD;
            if (stockStatusFilter === 'low-stock') return quantity > 0 && quantity <= LOW_STOCK_THRESHOLD;
            if (stockStatusFilter === 'out-of-stock') return quantity <= 0;
            return true;
        });

    const allFilteredSelected = filteredProducts.length > 0 && filteredProducts.every((product) => selectedProductIds.includes(product.ProductID));

    const toggleProductSelection = (productId) => {
        setSelectedProductIds((prev) =>
            prev.includes(productId)
                ? prev.filter((id) => id !== productId)
                : [...prev, productId]
        );
    };

    const toggleSelectAllFiltered = () => {
        if (allFilteredSelected) {
            const filteredIds = new Set(filteredProducts.map((product) => product.ProductID));
            setSelectedProductIds((prev) => prev.filter((id) => !filteredIds.has(id)));
        } else {
            const filteredIds = filteredProducts.map((product) => product.ProductID);
            setSelectedProductIds((prev) => Array.from(new Set([...prev, ...filteredIds])));
        }
    };

    const stockFilterOptions = [
        { key: 'all', label: t('stock_filter.all') },
        { key: 'in-stock', label: t('stock_filter.in_stock') },
        { key: 'low-stock', label: t('stock_filter.low_stock') },
        { key: 'out-of-stock', label: t('stock_filter.out_of_stock') },
    ];

    if (!isAdmin) {
        return (
            <div className="d-flex justify-content-center align-items-center" style={{ height: '100vh' }}>
                <Alert variant="danger" style={{ width: '80%', textAlign: 'center' }}>
                    Unauthorized: You do not have admin access.
                </Alert>
            </div>
        );
    }

    return (
        <AnimationRevealPage>
            <LightAdmin />
                         <div className="d-flex flex-column">
                <section className="w-100 p-3">
                    <div className="d-flex justify-content-between align-items-center mb-3">
                    <h6 className="text-dark display-4">{t('Tableau_de_bord_Produits')}</h6>
                    <button 
                        className="btn btn-lg"
                        style={{ 
                            backgroundColor: '#133b8c', // Use your primary color
                            color: 'white', 
                            border: 'none', 
                            padding: '10px 20px', 
                            fontSize: '16px', 
                            borderRadius: '5px' 
                        }} 
                        onClick={handleShowModal}
                    >
{t('ajouter_un_produit')}        
            </button>
                    
                     <input
        type="text"
        className="form-control w-auto"
        placeholder={t('Rechercher_par_nom_produits')}        
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
        style={{ maxWidth: '300px',marginLeft:"20px" }}
    />
                    </div>
                    <hr className="my-4" />
{/* Category Filter Buttons */}
<div className="mb-3 d-flex justify-content-center flex-wrap gap-2">
  {["All", "Cosmétiques & Compléments Alimentaires","Chaussures", "Cadeaux","Accessoires Téléphone","Électroménager","Bijou","Librairie & Papeterie","Montres","Parfums", "Textile & Habillement", "Produits Naturels", "Matériaux de Construction"].map(cat => (
    <button
      key={cat}
      className={`btn`}
      onClick={() => setSelectedCategory(cat)}
      style={{
        backgroundColor: selectedCategory === cat ? '#edbf03' : '#133b8c',
        color: 'white',
        border: 'none',
        padding: '10px 20px',
        borderRadius: '5px',
        cursor: 'pointer',
      }}
    >
      {t(cat)}
    </button>
  ))}
</div>

                    <hr className="my-4" />

                    <div className="mb-4 text-center">
                        {/* <h6 className="fw-bold">{t('stock_filter.title')}</h6> */}
                        <div className="d-flex flex-wrap justify-content-center gap-2">
                            {stockFilterOptions.map((option) => (
                                <button
                                    key={option.key}
                                    className="btn"
                                    onClick={() => setStockStatusFilter(option.key)}
                                    style={{
                                        backgroundColor: stockStatusFilter === option.key ? '#edbf03' : '#133b8c',
                                        color: 'white',
                                        border: 'none',
                                        padding: '10px 20px',
                                        borderRadius: '5px',
                                        cursor: 'pointer',
                                    }}
                                >
                                    {option.label}
                                </button>
                            ))}
                        </div>
                    </div>

                    <div className="row g-3 mb-4">
                        <div className="col-lg-6">
                            <div className="card shadow-sm h-100">
                                <div className="card-body">
                                    <h6 className="card-title fw-semibold">{t('bulk_actions.discount_title')}</h6>
                                    <p className="text-muted small mb-3">{t('bulk_actions.selected_count', { count: selectedProductIds.length })}</p>
                                    <div className="input-group mb-3">
                                        <input
                                            type="number"
                                            min="0"
                                            step="0.01"
                                            className="form-control"
                                            placeholder={t('bulk_actions.discount_placeholder')}
                                            value={discountValue}
                                            onChange={(e) => setDiscountValue(e.target.value)}
                                        />
                                        <span className="input-group-text">%</span>
                                    </div>
                                    <button
                                        className="btn"
                                        style={{ backgroundColor: '#133b8c', color: '#fff', border: 'none' }}
                                        onClick={applyDiscountToSelected}
                                        disabled={bulkLoading}
                                    >
                                        {bulkLoading ? t('Chargement...') : t('bulk_actions.apply_discount')}
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="card shadow-sm h-100">
                                <div className="card-body">
                                    <h6 className="card-title fw-semibold">{t('bulk_actions.stock_title')}</h6>
                                    <p className="text-muted small mb-3">{t('bulk_actions.selected_count', { count: selectedProductIds.length })}</p>
                                    <div className="row g-2 align-items-center mb-3">
                                        <div className="col-sm-5">
                                            <select
                                                className="form-select"
                                                value={stockChangeMode}
                                                onChange={(e) => setStockChangeMode(e.target.value)}
                                            >
                                                <option value="set">{t('bulk_actions.stock_mode_set')}</option>
                                                <option value="adjust">{t('bulk_actions.stock_mode_adjust')}</option>
                                            </select>
                                        </div>
                                        <div className="col-sm-7">
                                            <input
                                                type="number"
                                                className="form-control"
                                                placeholder={t('bulk_actions.stock_placeholder')}
                                                value={stockChangeValue}
                                                onChange={(e) => setStockChangeValue(e.target.value)}
                                            />
                                        </div>
                                    </div>
                                    <button
                                        className="btn"
                                        style={{ backgroundColor: '#133b8c', color: '#fff', border: 'none' }}
                                        onClick={applyStockChangeToSelected}
                                        disabled={bulkLoading}
                                    >
                                        {bulkLoading ? t('Chargement...') : t('bulk_actions.apply_stock_change')}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="table-responsive">
                        <table className="table table-striped table-hover">
                        <thead style={{ backgroundColor: '#AFA4CE' }}>
                        <tr>
                                <th>
                                    <input
                                        type="checkbox"
                                        checked={allFilteredSelected && filteredProducts.length > 0}
                                        onChange={toggleSelectAllFiltered}
                                    />
                                </th>
                                <th>{t('ID_du_produit')}</th>
                                <th>{t('Nom')}</th>
                                <th>{i18n.language === 'ar' ? 'وصف قصير' : 'Description courte'}</th>
                                <th>{t('Description')}</th>
                                <th>{t('Quantité_en_stock')}</th>
                                <th>{t('Prix_utilisateur')}</th>
                                <th>{t('Prix_distributeur_influenceur')}</th>
                                <th>{t('Catégorie')}</th>
                                <th>{t('Image')}</th>
                                <th>{t('Actions')}</th>
                                </tr>
                            </thead>
                            <tbody>
                                                                {filteredProducts.map((product) => {
                                    const resolveLocalized = (field) => {
                                        const v = product[field];
                                        if (!v) return '';
                                        if (typeof v === 'string') return v;
                                        if (typeof v === 'object') {
                                            return i18n.language === 'ar' ? (v.ar || v.fr || '') : (v.fr || v.ar || '');
                                        }
                                        return '';
                                    };
                                    const rawName = resolveLocalized('Name');
                                    const rawShort = resolveLocalized('short_description');
                                    const rawDesc = resolveLocalized('Description');
                                    const stripHtml = (html) => String(html || '').replace(/<[^>]*>/g, ' ').replace(/&nbsp;/g, ' ').replace(/\s+/g, ' ').trim();
                                                                        const shortText = stripHtml(rawShort);
                                                                        const descText = stripHtml(rawDesc);
                                                                        const isShortExpanded = !!expandShortById[product.ProductID];
                                                                        const isDescExpanded = !!expandDescById[product.ProductID];
                                                                    const isSelected = selectedProductIds.includes(product.ProductID);
                                    const quantity = Number(product.StockQuantity) || 0;
                                    const isOutOfStock = quantity <= 0;
                                    const isLowStock = quantity > 0 && quantity < LOW_STOCK_THRESHOLD;
                                    const stockCellStyle = isOutOfStock
                                        ? { color: '#dc3545', fontWeight: 600 }
                                        : isLowStock
                                            ? { color: '#ffc107', fontWeight: 600 }
                                            : {};
                                    const quantityDisplay = isOutOfStock
                                        ? t('stock_filter.out_of_stock')
                                        : isLowStock
                                            ? `${quantity} (${t('stock_filter.low_stock')})`
                                            : quantity;
                                    return (
                                        <tr key={product.ProductID}>
                                                                            <td>
                                                                                <input
                                                                                    type="checkbox"
                                                                                    checked={isSelected}
                                                                                    onChange={() => toggleProductSelection(product.ProductID)}
                                                                                />
                                                                            </td>
                                                                            <td>{product.ProductID}</td>
                                            <td>{rawName || t('Nom')}</td>
                                                                                        <td title={shortText}>
                                                                                            <div
                                                                                                style={{
                                                                                                    lineHeight: '1.6rem',
                                                                                                    fontSize: '14px',
                                                                                                    ...(isShortExpanded ? {} : {
                                                                                                        overflow: 'hidden',
                                                                                                        display: '-webkit-box',
                                                                                                        WebkitLineClamp: 3,
                                                                                                        WebkitBoxOrient: 'vertical',
                                                                                                    })
                                                                                                }}
                                                                                            >
                                                                                                {shortText}
                                                                                            </div>
                                                                                            {shortText && (
                                                                                                <button
                                                                                                    type="button"
                                                                                                    className="btn btn-link p-0 mt-1"
                                                                                                    onClick={() => setExpandShortById(prev => ({ ...prev, [product.ProductID]: !isShortExpanded }))}
                                                                                                    style={{ color: '#1e3d56' }}
                                                                                                >
                                                                                                    {i18n.language === 'ar'
                                                                                                        ? (isShortExpanded ? 'عرض أقل' : 'عرض المزيد')
                                                                                                        : (isShortExpanded ? 'Voir moins' : 'Voir plus')}
                                                                                                </button>
                                                                                            )}
                                                                                        </td>
                                                                                        <td title={descText}>
                                                                                            <div
                                                                                                style={{
                                                                                                    lineHeight: '1.6rem',
                                                                                                    fontSize: '14px',
                                                                                                    ...(isDescExpanded ? {} : {
                                                                                                        overflow: 'hidden',
                                                                                                        display: '-webkit-box',
                                                                                                        WebkitLineClamp: 3,
                                                                                                        WebkitBoxOrient: 'vertical',
                                                                                                    })
                                                                                                }}
                                                                                            >
                                                                                                {descText}
                                                                                            </div>
                                                                                            {descText && (
                                                                                                <button
                                                                                                    type="button"
                                                                                                    className="btn btn-link p-0 mt-1"
                                                                                                    onClick={() => setExpandDescById(prev => ({ ...prev, [product.ProductID]: !isDescExpanded }))}
                                                                                                    style={{ color: '#1e3d56' }}
                                                                                                >
                                                                                                    {i18n.language === 'ar'
                                                                                                        ? (isDescExpanded ? 'عرض أقل' : 'عرض المزيد')
                                                                                                        : (isDescExpanded ? 'Voir moins' : 'Voir plus')}
                                                                                                </button>
                                                                                            )}
                                                                                        </td>
                                            <td style={stockCellStyle}>{quantityDisplay}</td>
                                            <td>{product.user_price}{t('currency')}</td>
                                            <td>{product.distributeur_price} {t('currency')}</td>
                                            <td>{product.Category}</td>
                                            <td>
                                                {product.image ? (
                                                    <img
                                                        src={`https://plateformewmg.cloud/storage/${product.image}`}
                                                        alt={rawName}
                                                        style={{ width: '50px', height: '50px', objectFit: 'contain' }}
                                                        onError={(e) => { e.currentTarget.style.opacity = '0.3'; e.currentTarget.title = 'Image introuvable'; }}
                                                    />
                                                ) : (
                                                    'No Image'
                                                )}
                                            </td>
                                            <td>
                                                <button className="btn btn-warning btn-sm me-2" onClick={() => handleEdit(product.ProductID)}>
                                                    <FaEdit />
                                                </button>
                                                <button
                                                    style={{ backgroundColor: 'red' }}
                                                    className="btn btn-danger btn-sm"
                                                    onClick={() => handleDelete(product.ProductID)}
                                                >
                                                    <FaTrash style={{ color: 'white' }} />
                                                </button>
                                            </td>
                                        </tr>
                                    );
                                })}
                                                        </tbody>
                                                </table>
                                        </div>
                                </section>
                        </div>
                        <Footer />
                        <Modal show={showModal} onHide={handleCloseModal}>
                                <Modal.Header closeButton>
                                        <Modal.Title>{editingProductId ? t('Modifier_le_produit') : t('ajouter_un_produit')}</Modal.Title>
                                </Modal.Header>
                                <Modal.Body>
                                        <Form onSubmit={handleSubmit}>
                                                <Form.Group>
                                                        <Form.Label>{t('Nom')} (FR)</Form.Label>
                                                        <Form.Control
                                type="text"
                                value={newProduct.Name.fr}
                                onChange={(e) =>
                                    setNewProduct((prev) => ({
                                        ...prev,
                                        Name: { ...prev.Name, fr: e.target.value }
                                    }))
                                }
                                required
                            />
                                                </Form.Group>

                        <Form.Group>
                            <Form.Label>{t('Nom')} (AR)</Form.Label>
                            <Form.Control
                                type="text"
                                value={newProduct.Name.ar}
                                onChange={(e) =>
                                    setNewProduct((prev) => ({
                                        ...prev,
                                        Name: { ...prev.Name, ar: e.target.value }
                                    }))
                                }
                                required
                            />
                        </Form.Group>

                                                <Form.Group>
                                                    <Form.Label>{i18n.language === 'ar' ? 'وصف قصير (FR)' : 'Description courte (FR)'}</Form.Label>
                                                    <ReactQuill
                                                        theme="snow"
                                                        value={newProduct.short_description.fr}
                                                        onChange={(value) =>
                                                            setNewProduct((prev) => ({
                                                                ...prev,
                                                                short_description: { ...prev.short_description, fr: value }
                                                            }))
                                                        }
                                                    />
                                                </Form.Group>

                                                <Form.Group>
                                                    <Form.Label>{i18n.language === 'ar' ? 'وصف قصير (AR)' : 'Description courte (AR)'}</Form.Label>
                                                    <ReactQuill
                                                        theme="snow"
                                                        value={newProduct.short_description.ar}
                                                        onChange={(value) =>
                                                            setNewProduct((prev) => ({
                                                                ...prev,
                                                                short_description: { ...prev.short_description, ar: value }
                                                            }))
                                                        }
                                                    />
                                                </Form.Group>

                                            <Form.Group>
  <Form.Label>{t('Description')} (FR)</Form.Label>
  <ReactQuill
    theme="snow"
    value={newProduct.Description.fr}
    onChange={(value) =>
      setNewProduct((prev) => ({
        ...prev,
        Description: { ...prev.Description, fr: value }
      }))
    }
  />
</Form.Group>

<Form.Group>
  <Form.Label>{t('Description')} (AR)</Form.Label>
  <ReactQuill
    theme="snow"
    value={newProduct.Description.ar}
    onChange={(value) =>
      setNewProduct((prev) => ({
        ...prev,
        Description: { ...prev.Description, ar: value }
      }))
    }
  />
</Form.Group>


                        <Form.Group>
                            <Form.Label>{t('Prix_utilisateur')}</Form.Label>
                            <Form.Control
                                type="number"
                                name="user_price"
                                value={newProduct.user_price}
                                onChange={handleChange}
                                required
                            />
                        </Form.Group>

                        <Form.Group>
                            <Form.Label>{t('Prix_distributeur_influenceur')}</Form.Label>
                            <Form.Control
                                type="number"
                                name="distributeur_price"
                                value={newProduct.distributeur_price}
                                onChange={handleChange}
                                required
                            />
                        </Form.Group>

                        <Form.Group>
                            <Form.Label>{t('Quantité_en_stock')}</Form.Label>
                            <Form.Control
                                type="number"
                                name="StockQuantity"
                                value={newProduct.StockQuantity}
                                onChange={handleChange}
                                required
                            />
                        </Form.Group>

                                                <Form.Group>
                                                    <Form.Label>{t('Catégorie')}</Form.Label>
                                                    <Form.Control
                                                        as="select"
                                                        name="Category"
                                                        value={newProduct.Category}
                                                        onChange={handleChange}
                                                        required
                                                    >
                                                        {categoryOptions.map(opt => (
                                                            <option key={opt} value={opt}>{opt}</option>
                                                        ))}
                                                    </Form.Control>
                                                </Form.Group>

                        {editingProductId && (
                            <div className="mb-3">
                                <Form.Label>{t('Image_actuelle')}</Form.Label><br />
                                {typeof newProduct.image === 'string' && (
                                    <img
                                        src={`  https://plateformewmg.cloud/storage/${newProduct.image}`}
                                        alt="Product"
                                        style={{ maxWidth: "150px", borderRadius: "5px", marginBottom: "10px" }}
                                    />
                                )}
                                <Form.Control
                                    type="file"
                                    name="image"
                                    onChange={(e) => setNewProduct({ ...newProduct, image: e.target.files[0] })}
                                />
                            </div>
                        )}

                        {!editingProductId && (
                            <Form.Group>
                                <Form.Label>{t('Image')}</Form.Label>
                                <Form.Control
                                    type="file"
                                    name="image"
                                    onChange={(e) => setNewProduct({ ...newProduct, image: e.target.files[0] })}
                                    required
                                />
                            </Form.Group>
                        )}

                        <Button
                            variant="primary"
                            type="submit"
                            className="mt-3"
                            disabled={loading}
                        >
                            {loading ? t('Chargement...') : editingProductId ? t('Modifier') : t('Ajouter')}
                        </Button>
                    </Form>
                </Modal.Body>
            </Modal>
        </AnimationRevealPage>
    );
};

export default ProduitsAdmin;
